import { Button } from '@neo/index'
import { Typography } from '@neo/primitives/typography'
import type { ChatMenuButtons } from '../types'
import { useSendMessage } from './use-send-message'
import { handleChatButtonClick, shouldDisableButton } from './utils/button-handlers'

interface ChatMenuButtonsProps {
  content: ChatMenuButtons
  isLastChunk: boolean
}

export const ChatMenuButtonsComponent = ({ content, isLastChunk }: ChatMenuButtonsProps) => {
  const { sendMessage, isSending } = useSendMessage()

  if (!content.message || content.message.length === 0) return null

  const menuItem = content.message[0]
  if (!menuItem.buttons || menuItem.buttons.length === 0) return null

  const handleButtonClick = (buttonText: string, buttonType: string, buttonId: string) => {
    handleChatButtonClick(
      buttonText,
      buttonType,
      buttonId,
      menuItem.buttons,
      sendMessage,
      isSending,
    )
  }

  return (
    <div className="flex min-w-0 flex-col gap-2">
      {menuItem.title && (
        <Typography variant="H4/500" className="text-foreground break-words">
          {menuItem.title}
        </Typography>
      )}
      <div className="flex flex-wrap gap-2">
        {menuItem.buttons.map((button) => {
          return (
            <Button
              variant="outline"
              key={button.id}
              disabled={shouldDisableButton(button.button_type, isLastChunk, isSending)}
              data-testid={`chat-menu-button-${button.id}`}
              onClick={() => handleButtonClick(button.text, button.button_type, button.id)}
              type="button"
              className="h-auto max-w-full whitespace-normal py-2 px-3 font-inter tracking-normal normal-case"
            >
              <Typography
                variant="S/400"
                className="text-foreground break-words [overflow-wrap:anywhere]"
              >
                {button.text}
              </Typography>
            </Button>
          )
        })}
      </div>
    </div>
  )
}
